export const FUNNEL_REPORTS_TEST_IDS = {
  page: 'funnel-reports-page',
  /** Starts cell: journeys + the distinct-people second line (bot-filter phase 1). */
  startsUniqueCell: 'funnel-reports-starts-unique',
  scopeProject: 'funnel-reports-scope-project',
  scopeOnboarding: 'funnel-reports-scope-onboarding',
  scopeVersion: 'funnel-reports-scope-version',
  scopeAlias: 'funnel-reports-scope-alias',
  onboardingSelect: 'funnel-reports-onboarding-select',
  versionSelect: 'funnel-reports-version-select',
  aliasInput: 'funnel-reports-alias-input',
  fromInput: 'funnel-reports-from-input',
  toInput: 'funnel-reports-to-input',
  targetInput: 'funnel-reports-target-input',
  paidCampaignInput: 'funnel-reports-paid-campaign-input',
  metaAdAccountInput: 'funnel-reports-meta-ad-account-input',
  metaCampaignInput: 'funnel-reports-meta-campaign-input',
  metaAdsetInput: 'funnel-reports-meta-adset-input',
  metaAdInput: 'funnel-reports-meta-ad-input',
  metaCreativeInput: 'funnel-reports-meta-creative-input',
  matchQualityInput: 'funnel-reports-match-quality-input',
  scopeSelectorStatus: 'funnel-reports-scope-selector-status',
  /** R1 — L0 scope-bar restructure (presets, advanced-filters accordion, QA menu). */
  datePreset: (id: string) => `funnel-reports-date-preset-${id}`,
  /**
   * A3 (studio-reports redesign): the header's date block — one trigger that
   * states the window and opens the picker popover. The date controls are the
   * only page state a non-admin always keeps (VISIBILITY_SPEC).
   */
  /** P1-10: the applied scope, by name, under the page title. */
  reportsScopeSummary: 'funnel-reports-scope-summary',
  reportsDateTrigger: 'funnel-reports-date-trigger',
  reportsDatePopover: 'funnel-reports-date-popover',
  /** A3: «vs previous N days» — rendered ONLY when a prior window was served. */
  reportsComparisonCaption: 'funnel-reports-comparison-caption',
  freshnessCaption: 'funnel-reports-freshness-caption',
  /** PE-6 (D-P4) — draft/applied scope split: Apply commits the form to the fetch. */
  reportsApply: 'funnel-reports-apply',
  /** A4: the Advanced-filters panel's own commit — same draft, same handler. */
  reportsApplyFilters: 'funnel-reports-apply-filters',
  reportsPendingHint: 'funnel-reports-pending-hint',
  /** PE-6 (D-P2/D-P3) — coverage-driven ready-period picker. */
  reportsPeriodSelect: 'funnel-reports-period-select',
  reportsCoverageCaption: 'funnel-reports-coverage-caption',
  /** reports-timezone-select — IANA zone the calendar days are interpreted in. */
  reportsTimezoneSelect: 'funnel-reports-timezone-select',
  /** F2 (FT-AC-084): counting-unit toggle on the scope bar — INSTANT, never Apply-gated. */
  reportsUnitToggle: 'funnel-reports-unit-toggle',
  reportsUnitToggleOption: (unit: 'people' | 'visits') => `funnel-reports-unit-toggle-${unit}`,
  /** R-wave (FT-AC-111): why the placement rows add up higher than the people
   * headline. People mode + more than one placement only — visible, never a tooltip. */
  peopleScopeCaption: 'funnel-reports-people-scope-caption',
  /** D-U1 (FT-AC-119): the «visits» marker on a journey-only A/B variant sub-row. */
  abVariantUnitChip: 'funnel-reports-ab-variant-unit',
  /** FU part D (D-F1) — cached-first open banner (fresh fetch ONLY on explicit action). */
  cachedBanner: 'funnel-reports-cached-banner',
  cachedRefresh: 'funnel-reports-cached-refresh',
  advancedFiltersToggle: 'funnel-reports-advanced-filters-toggle',
  qaMenuButton: 'funnel-reports-qa-menu-button',
  qaMenu: 'funnel-reports-qa-menu',
  qaProvenance: 'funnel-reports-qa-provenance',
  anchorNav: 'funnel-reports-anchor-nav',
  audienceSection: 'funnel-reports-audience-section',
  audienceToggle: 'funnel-reports-audience-toggle',
  chartToggle: (id: string) => `funnel-reports-chart-toggle-${id}`,
  /** The one-line answer a COLLAPSED section row carries (hidden once open). */
  chartSummary: (id: string) => `funnel-reports-chart-summary-${id}`,
  leaderboardColumnsToggle: 'funnel-reports-leaderboard-columns-toggle',
  // R2 — funnel-first visualization (hero funnel + step drill + payments rates)
  funnelHero: 'funnel-reports-funnel-hero',
  funnelViewToggle: 'funnel-reports-funnel-view-toggle',
  funnelView: (view: string) => `funnel-reports-funnel-view-${view}`,
  funnelStep: (screenId: string) => `funnel-reports-funnel-step-${screenId}`,
  funnelArrows: 'funnel-reports-funnel-arrows',
  funnelDrill: 'funnel-reports-funnel-drill',
  funnelDrillExits: 'funnel-reports-funnel-drill-exits',
  funnelCanvasLink: 'funnel-reports-funnel-canvas-link',
  paymentsRates: 'funnel-reports-payments-rates',
  paymentsRevenuePerStart: 'funnel-reports-payments-revenue-per-start',
  paymentsDataThrough: 'funnel-reports-payments-data-through',
  // R3-4 — «What changed» merged insight feed (anomalies + inline drivers)
  whatChangedFeed: 'funnel-reports-what-changed',
  whatChangedItem: (anomalyId: string) => `funnel-reports-what-changed-${anomalyId}`,
  whatChangedDrivers: (anomalyId: string) => `funnel-reports-what-changed-drivers-${anomalyId}`,
  whatChangedAllHealthy: 'funnel-reports-what-changed-all-healthy',
  // R4-1 — report-level trust layer (P9 on every surface)
  trustBanner: 'funnel-reports-trust-banner',
  kpiSeverity: (id: string) => `funnel-reports-kpi-severity-${id}`,
  // R4-2 — Data Quality leads with a health line; the audit table demotes behind <details>
  dataQualityHealthLine: 'funnel-reports-data-quality-health-line',
  // R4-3 — freshness captions on every time-series (payments caption generalized)
  metricTrendsDataThrough: 'funnel-reports-metric-trends-data-through',
  dataQualityDataThrough: 'funnel-reports-data-quality-data-through',
  funnelTrendDataThrough: 'funnel-reports-funnel-trend-data-through',
  dryRunToggle: 'funnel-reports-dry-run-toggle',
  showEmptyReportsToggle: 'funnel-reports-show-empty-toggle',
  refreshButton: 'funnel-reports-refresh-button',
  projectSyncStatus: 'funnel-reports-project-sync-status',
  refreshStatus: 'funnel-reports-refresh-status',
  refreshSummary: 'funnel-reports-refresh-summary',
  dashboardAvailabilityStatus: 'funnel-reports-dashboard-availability-status',
  reportGridAvailabilityStatus: 'funnel-reports-grid-availability-status',
  reportGrid: 'funnel-reports-grid',
  nativeDashboard: 'funnel-reports-native-dashboard',
  dashboardStatus: 'funnel-reports-dashboard-status',
  /** R0-1 — de-multiplexed dashboard alert surfaces (each failure mode has its own element). */
  dashboardScopePrompt: 'funnel-reports-dashboard-scope-prompt',
  dashboardErrorDetails: 'funnel-reports-dashboard-error-details',
  dashboardWarnings: 'funnel-reports-dashboard-warnings',
  abDecisionStatus: 'funnel-reports-ab-decision-status',
  dashboardSectionFailure: 'funnel-reports-dashboard-section-failure',
  chartError: (id: string) => `funnel-reports-chart-error-${id}`,
  chartErrorDetails: (id: string) => `funnel-reports-chart-error-details-${id}`,
  /**
   * D5: the rate cell's confidence affordance and the card it opens. The rate
   * itself is the trigger — pointer and keyboard (AC-011).
   */
  rateConfidenceTrigger: 'funnel-reports-rate-confidence-trigger',
  rateConfidenceCard: 'funnel-reports-rate-confidence-card',
  projectOverview: 'funnel-reports-project-overview',
  projectOverviewStat: (id: string) => `funnel-reports-project-overview-${id}`,
  /** B3: the band's display-only escape from a people-absent scope. */
  projectOverviewShowVisits: 'funnel-reports-project-overview-show-visits',
  kpi: (id: string) => `funnel-reports-kpi-${id}`,
  kpiDelta: (id: string) => `funnel-reports-kpi-delta-${id}`,
  chart: (id: string) => `funnel-reports-chart-${id}`,
  chartEmpty: (id: string) => `funnel-reports-chart-empty-${id}`,
  chartEvidence: (id: string) => `funnel-reports-chart-evidence-${id}`,
  activeAliasAction: (alias: string) => `funnel-reports-active-alias-${alias}`,
  activeOnboardingAction: (alias: string, onboardingId: string, versionId: string) => (
    `funnel-reports-active-onboarding-${alias}-${onboardingId}-${versionId}`
  ),
  card: (id: string) => `funnel-reports-card-${id}`,
  openReport: (id: string) => `funnel-reports-open-${id}`,
  attentionStrip: 'funnel-reports-attention-strip',
  attentionAllClear: 'funnel-reports-attention-all-clear',
  attentionItem: (id: string) => `funnel-reports-attention-item-${id}`,
  /** R5-4 — deep-link Open action on strip items (SRM → Experiments hub, decide → scorecards). */
  attentionItemOpen: (id: string) => `funnel-reports-attention-open-${id}`,
  warningsSection: 'funnel-reports-warnings-section',
  warningsItem: (id: string) => `funnel-reports-warnings-item-${id}`,
  openPlacementEntity: (alias: string) => `funnel-reports-open-placement-${alias}`,
  openOnboardingEntity: (alias: string, onboardingId: string) => (
    `funnel-reports-open-onboarding-${alias}-${onboardingId}`
  ),
  /** FU part E (D-F2) — A/B placement inline variant sub-rows (+ report-mode new-tab link). */
  abVariantRow: (alias: string, variantId: string) => `funnel-reports-ab-variant-${alias}-${variantId}`,
  abVariantOpenReport: (alias: string, variantId: string) => `funnel-reports-ab-variant-open-${alias}-${variantId}`,
  /** L1/A1 — multi-version onboarding rows: «Versions (N)» chevron + inline version sub-rows. */
  versionsToggle: (alias: string, onboardingId: string) => `funnel-reports-versions-toggle-${alias}-${onboardingId}`,
  versionRow: (alias: string, onboardingId: string, versionId: string) => (
    `funnel-reports-version-row-${alias}-${onboardingId}-${versionId}`
  ),
  versionOpenReport: (alias: string, onboardingId: string, versionId: string) => (
    `funnel-reports-version-open-${alias}-${onboardingId}-${versionId}`
  ),
  /** People-attribution S5 — the grouped versions table (replaces the placements table). */
  versionGroupHeader: (alias: string) => `funnel-reports-version-group-${alias}`,
  versionsUnitCaption: 'funnel-reports-versions-unit-caption',
  versionsGateBasisCaption: 'funnel-reports-versions-gate-basis-caption',
  /** People-attribution S6 — the Traffic sources view (campaigns / creatives in people). */
  trafficSourcesOpen: 'funnel-reports-traffic-sources-open',
  trafficSourcesBack: 'funnel-reports-traffic-sources-back',
  trafficSourcesPanel: 'funnel-reports-traffic-sources-panel',
  trafficSourcesTab: (kind: 'campaigns' | 'creatives') => `funnel-reports-traffic-sources-tab-${kind}`,
  trafficSourcesCaption: 'funnel-reports-traffic-sources-caption',
  trafficSourceRow: (kind: 'campaign' | 'creative', id: string) => `funnel-reports-traffic-source-${kind}-${id}`,
  trafficSourcesTotalRow: 'funnel-reports-traffic-sources-total',
  metaSevenDayClickCell: (kind: 'campaign' | 'creative', id: string) => `funnel-reports-meta-7d-click-${kind}-${id}`,
  /** People-attribution S10 — «Traffic into this funnel»: row button, popup, page. */
  versionSources: (alias: string, onboardingId: string, versionId: string) => (
    `funnel-reports-version-sources-${alias}-${onboardingId}-${versionId}`
  ),
  trafficIntoFunnelDialog: 'funnel-reports-traffic-into-funnel-dialog',
  trafficIntoFunnelPage: 'funnel-reports-traffic-into-funnel-page',
  trafficIntoFunnelView: 'funnel-reports-traffic-into-funnel-view',
  trafficIntoFunnelOpenAsPage: 'funnel-reports-traffic-into-funnel-open-as-page',
  trafficIntoFunnelBack: 'funnel-reports-traffic-into-funnel-back',
  trafficIntoFunnelUnitSelect: 'funnel-reports-traffic-into-funnel-unit',
  trafficIntoFunnelCaption: 'funnel-reports-traffic-into-funnel-caption',
  trafficIntoFunnelTab: (kind: 'campaigns' | 'creatives') => `funnel-reports-traffic-into-funnel-tab-${kind}`,
  trafficIntoFunnelRow: (kind: 'campaign' | 'creative', id: string) => `funnel-reports-traffic-into-funnel-${kind}-${id}`,
  /** Phase 2-min: «Unit economics →» on a campaign row → hub ?tab=pricing prefilled (AC-038). */
  trafficIntoFunnelRowEconomics: (id: string) => `funnel-reports-traffic-into-funnel-row-economics-${id}`,
  trafficIntoFunnelShareCell: (kind: 'campaign' | 'creative', id: string) => `funnel-reports-traffic-into-funnel-share-${kind}-${id}`,
  // S11 §14.2: CAC and pLTV are two adjacent cells (D-J by adjacency).
  trafficIntoFunnelCacCell: (kind: 'campaign' | 'creative', id: string) => `funnel-reports-traffic-into-funnel-cac-${kind}-${id}`,
  trafficIntoFunnelPltvCell: (kind: 'campaign' | 'creative', id: string) => `funnel-reports-traffic-into-funnel-pltv-${kind}-${id}`,
  /** §6 #8 (2026-09-02): the pLTV ROAS cell — served pltv12Roas toned by its interval bounds vs 1×. */
  trafficIntoFunnelPltvRoasCell: (kind: 'campaign' | 'creative', id: string) => `funnel-reports-traffic-into-funnel-pltv-roas-${kind}-${id}`,
  /** Phase 2 chips (AC-069): the campaign row's zone reading under the source name. */
  trafficIntoFunnelRowVerdict: (id: string) => `funnel-reports-traffic-into-funnel-row-verdict-${id}`,
  /** S12 §15.2: the source's FULL window spend beside the shared spend. */
  trafficIntoFunnelWindowSpendCell: (kind: 'campaign' | 'creative', id: string) => `funnel-reports-traffic-into-funnel-window-spend-${kind}-${id}`,
  /** S12 §15.4a: the row's subscriptions by billing class («258 monthly · 137 upfront»). */
  trafficIntoFunnelProductsCell: (kind: 'campaign' | 'creative', id: string) => `funnel-reports-traffic-into-funnel-products-${kind}-${id}`,
  /** S13 §17.1 item 7: one row per product (price_id) inside the Products cell. */
  trafficIntoFunnelProductRow: (kind: 'campaign' | 'creative', id: string, priceKey: string) => `funnel-reports-traffic-into-funnel-product-${kind}-${id}-${priceKey}`,
  /** S12 §15.3: the watch-only pLTV band chip inside the pLTV cell (I4 grammar). */
  trafficIntoFunnelWatchOnlyChip: (kind: 'campaign' | 'creative', id: string) => `funnel-reports-traffic-into-funnel-watch-only-${kind}-${id}`,
  trafficIntoFunnelTotalRow: 'funnel-reports-traffic-into-funnel-total',
  // S13 wave D: filter creatives by campaign, both directions (client-side).
  trafficIntoFunnelCampaignCreativesLink: (campaignId: string) => `funnel-reports-traffic-into-funnel-campaign-creatives-${campaignId}`,
  trafficIntoFunnelCampaignCreativesAbsence: (rowId: string) => `funnel-reports-traffic-into-funnel-campaign-creatives-absence-${rowId}`,
  trafficIntoFunnelCampaignStrip: 'funnel-reports-traffic-into-funnel-campaign-strip',
  trafficIntoFunnelCampaignFilterChip: 'funnel-reports-traffic-into-funnel-campaign-chip',
  trafficIntoFunnelCampaignStripLink: 'funnel-reports-traffic-into-funnel-campaign-strip-link',
  trafficIntoFunnelCreativeCampaignFilter: (adId: string) => `funnel-reports-traffic-into-funnel-creative-campaign-filter-${adId}`,
  trafficIntoFunnelCreativeCampaignJump: (adId: string) => `funnel-reports-traffic-into-funnel-creative-campaign-jump-${adId}`,
  trafficIntoFunnelCreativeCampaignAbsence: (adId: string) => `funnel-reports-traffic-into-funnel-creative-campaign-absence-${adId}`,
  trafficIntoFunnelLoading: 'funnel-reports-traffic-into-funnel-loading',
  /** People-attribution S7 — D-J: the CAC line beside every pLTV figure. */
  pltvCacLine: (kind: 'campaign' | 'creative', index: number) => `funnel-reports-pltv-cac-${kind}-${index}`,
  /** Package B — Meta spend match tiers + creative performance section. */
  paidMatchCell: (index: number) => `funnel-reports-paid-match-${index}`,
  paidSpendCell: (index: number) => `funnel-reports-paid-spend-${index}`,
  /** paid-acquisition-table-ux — money-first sortable columns. */
  paidRevenueCell: (index: number) => `funnel-reports-paid-revenue-${index}`,
  paidLtvCell: (index: number) => `funnel-reports-paid-ltv-${index}`,
  // W-R5 rider: collected-checks line inside the realized-value cell.
  paidChecksCollected: (index: number) => `funnel-reports-paid-checks-collected-${index}`,
  // W-R5 (DISC-AC-144): degraded caption when a cached payload has no tiles.
  paidSummaryTilesUnavailable: 'funnel-reports-paid-summary-tiles-unavailable',
  paidRoasCell: (index: number) => `funnel-reports-paid-roas-${index}`,
  paidRoasLtvCell: (index: number) => `funnel-reports-paid-roas-ltv-${index}`,
  paidMoreColumnsToggle: 'funnel-reports-paid-more-columns-toggle',
  paidFullscreenOpen: 'funnel-reports-paid-fullscreen-open',
  paidFullscreenClose: 'funnel-reports-paid-fullscreen-close',
  paidCreativeDecisionsOpen: 'funnel-reports-paid-creative-decisions-open',
  /** W-R6 (DISC-AC-149/150): parity-period pointer card replacing the deleted
   * standalone Creative Diagnostics + Creative Performance sections. */
  creativeSectionsMovedCard: 'funnel-reports-creative-sections-moved',
  creativeSectionsMovedOpen: 'funnel-reports-creative-sections-moved-open',
  creativeSectionsMovedDiagnostics: 'funnel-reports-creative-sections-moved-diagnostics',
  /** Matched-campaign creatives drill-down inside Paid Acquisition. */
  paidCreativesToggle: (index: number) => `funnel-reports-paid-creatives-toggle-${index}`,
  paidCreativeRow: (index: number, creativeIndex: number) => `funnel-reports-paid-creative-${index}-${creativeIndex}`,
  /** Mapped-only section totals + the table-scope filter toggle. */
  paidSummaryAdSpend: 'funnel-reports-paid-summary-ad-spend',
  paidSummaryAdRevenue: 'funnel-reports-paid-summary-ad-revenue',
  paidSummaryRoas: 'funnel-reports-paid-summary-roas',
  paidSummaryLtv: 'funnel-reports-paid-summary-ltv',
  paidSummaryLtvRoas: 'funnel-reports-paid-summary-ltv-roas',
  /** Coverage-honest economics: covered tiles + the spend-coverage caption. */
  paidSummaryRevenueFullWindow: 'funnel-reports-paid-summary-revenue-full-window',
  paidSummaryCoverageCaption: 'funnel-reports-paid-summary-coverage-caption',
  /** AC-H-8: typed mixed-currency banner naming the FX-policy fix. */
  paidSummaryMixedCurrencyBanner: 'funnel-reports-paid-summary-mixed-currency-banner',
  paidMappedOnlyToggle: 'funnel-reports-paid-mapped-only-toggle',
  /** pLTV package — projected 12-month economics + verdict thresholds. */
  paidPltvCell: (index: number) => `funnel-reports-paid-pltv-${index}`,
  paidVerdictChip: (index: number) => `funnel-reports-paid-verdict-${index}`,
  paidCreativeWatchOnlyChip: (index: number, creativeIndex: number) => `funnel-reports-paid-creative-watch-only-${index}-${creativeIndex}`,
  /** I4 — campaign-grain watch-only pLTV band chip (pltv cell fallback, no link). */
  paidCampaignWatchOnlyChip: (index: number) => `funnel-reports-paid-campaign-watch-only-${index}`,
  /** DISC-AC-134 — cursor «Load more creatives» button in an expanded campaign drilldown. */
  paidCampaignCreativesLoadMore: (index: number) => `funnel-reports-paid-campaign-creatives-load-more-${index}`,
  /** DISC-AC-134 — first-expand loading sub-row while the full creative page fetches. */
  paidCampaignCreativesLoading: (index: number) => `funnel-reports-paid-campaign-creatives-loading-${index}`,
  /** I5c — server-diagnosed money root-cause rollup Alert (absent below the 60% bar). */
  paidMoneyRootCause: 'funnel-reports-paid-money-root-cause',
  /** I5c — «Technical details» disclosure inside the rollup (raw codes live here). */
  paidMoneyRootCauseDetails: 'funnel-reports-paid-money-root-cause-details',
  /** W-A.3 — boundary line inside a summary tile (`≥ $X · settled through <date> · N pending`). */
  paidSummaryTileBoundary: (tile: string) => `funnel-reports-paid-summary-${tile}-boundary`,
  /** W-A.9 — per-tile cause link: a withheld tile names its blocking mechanism (rule 7). */
  paidTileCause: (tile: string) => `funnel-reports-paid-tile-cause-${tile}`,
  /** W-A.8 — dispute caveat next to a rendered value when recent dispute events touch the window. */
  paidDisputeCaveat: (index: number) => `funnel-reports-paid-dispute-caveat-${index}`,
  paidSummaryPltvRoas: 'funnel-reports-paid-summary-pltv-roas',
  /** F3 (FT-AC-088) — visible attribution caption naming the ACTIVE model + window. */
  paidAttributionCaption: 'funnel-reports-paid-attribution-caption',
  /** F3 (FT-AC-089) — model selector; options carry the model id as data-value. */
  paidAttributionModelSelect: 'funnel-reports-paid-attribution-model-select',
  paidAttributionModelOption: (modelId: string) => `funnel-reports-paid-attribution-model-option-${modelId}`,
  /** F3 (D-F3-5) — view-through divergence note on the Meta-evidence column header. */
  paidMetaEvidenceNote: 'funnel-reports-paid-meta-evidence-note',
  paidThresholdsOpen: 'funnel-reports-paid-thresholds-open',
  paidThresholdsPopover: 'funnel-reports-paid-thresholds-popover',
  paidThresholdsKillInput: 'funnel-reports-paid-thresholds-kill',
  paidThresholdsScaleInput: 'funnel-reports-paid-thresholds-scale',
  paidThresholdsAgeInput: 'funnel-reports-paid-thresholds-age',
  paidThresholdsError: 'funnel-reports-paid-thresholds-error',
  paidThresholdsSave: 'funnel-reports-paid-thresholds-save',
  paidThresholdsReset: 'funnel-reports-paid-thresholds-reset',
  unmatchedSpendHint: 'funnel-reports-unmatched-spend-hint',
  unmatchedSpendHintCopy: 'funnel-reports-unmatched-spend-hint-copy',
  /** J1-I1 — Journey Cohort Census section (consume-only; honest degraded states). */
  cohortCensus: 'funnel-reports-cohort-census',
  cohortCensusModel: 'funnel-reports-cohort-census-model',
  cohortCensusModelDegraded: 'funnel-reports-cohort-census-model-degraded',
  cohortCensusSaved: 'funnel-reports-cohort-census-saved',
  cohortCensusTwoWay: 'funnel-reports-cohort-census-two-way',
  cohortCensusSmallN: 'funnel-reports-cohort-census-small-n',
  cohortCensusCoverage: 'funnel-reports-cohort-census-coverage',
} as const;

export const CREATIVE_DECISIONS_TEST_IDS = {
  page: 'creative-decisions-page',
  /** W-R6 (DISC-AC-149/150): saved-view tabs bound to `?view=`. */
  viewTabs: 'creative-decisions-view-tabs',
  viewTab: (view: 'decisions' | 'performance' | 'diagnostics') => `creative-decisions-view-tab-${view}`,
  performanceView: 'creative-decisions-performance-view',
  performanceRow: (index: number) => `creative-decisions-performance-row-${index}`,
  /** S7 / D-J: the CAC line beside the drawer's watch-only pLTV band. */
  drawerWatchOnlyCacLine: 'creative-decisions-drawer-watch-only-cac',
  performanceMatchedOnlyToggle: 'creative-decisions-performance-matched-only',
  performanceEmpty: 'creative-decisions-performance-empty',
  performanceError: 'creative-decisions-performance-error',
  performanceLoading: 'creative-decisions-performance-loading',
  /** W-R6 I2 step 0 — paid facet filters on the saved views (PRE-021 §1f/§2f parity). */
  performanceFiltersToggle: 'creative-decisions-performance-filters-toggle',
  performanceFilter: (facet: string) => `creative-decisions-performance-filter-${facet}`,
  performanceFilteredEmpty: 'creative-decisions-performance-filtered-empty',
  diagnosticsView: 'creative-decisions-diagnostics-view',
  diagnosticsRow: (index: number) => `creative-decisions-diagnostics-row-${index}`,
  diagnosticsScopeNote: 'creative-decisions-diagnostics-scope-note',
  diagnosticsFiltersToggle: 'creative-decisions-diagnostics-filters-toggle',
  diagnosticsFilter: (facet: string) => `creative-decisions-diagnostics-filter-${facet}`,
  diagnosticsFilteredEmpty: 'creative-decisions-diagnostics-filtered-empty',
  diagnosticsEmpty: 'creative-decisions-diagnostics-empty',
  diagnosticsError: 'creative-decisions-diagnostics-error',
  diagnosticsLoading: 'creative-decisions-diagnostics-loading',
  summary: 'creative-decisions-summary',
  summaryBucket: (currency: string) => `creative-decisions-summary-${currency.toLowerCase()}`,
  /** W-A.5 (D4) — pending-settlement spend tile, split from Unreconciled (pending ≠ failed). */
  summaryPendingSettlement: 'creative-decisions-summary-pending-settlement',
  /** W-A.5 (D4) — trust-blocked spend tile, split from Unreconciled (operator action, own cause). */
  summaryTrustBlocked: 'creative-decisions-summary-trust-blocked',
  globalOrderBlocked: 'creative-decisions-global-order-blocked',
  /** AC-H-8: project-level «money reporting policy not configured» banner. */
  moneyPolicyBanner: 'creative-decisions-money-policy-banner',
  /** I5b state 2 — «policy registered, rows unbound» re-sync CTA. */
  moneyPolicyResync: 'creative-decisions-money-policy-resync',
  /** I5b state 3 — partial binding muted caption (N of M unbound). */
  moneyPolicyPartialLine: 'creative-decisions-money-policy-partial',
  sortMoneyFlow: 'creative-decisions-sort-money-flow',
  sortNeedsAction: 'creative-decisions-sort-needs-action',
  sortHistoricalSpend: 'creative-decisions-sort-historical-spend',
  search: 'creative-decisions-search',
  filterToggle: 'creative-decisions-filter-toggle',
  scopeToggle: 'creative-decisions-scope-toggle',
  outOfScopeFooter: 'creative-decisions-out-of-scope-footer',
  portfolioSnapshotBanner: 'creative-decisions-portfolio-snapshot-banner',
  portfolioSnapshotRefresh: 'creative-decisions-portfolio-snapshot-refresh',
  filterPanel: 'creative-decisions-filter-panel',
  filterProvider: 'creative-decisions-filter-provider',
  filterAccount: 'creative-decisions-filter-account',
  filterLifecycle: 'creative-decisions-filter-lifecycle',
  filterDataState: 'creative-decisions-filter-data-state',
  filterDecision: 'creative-decisions-filter-decision',
  filterEvidenceClass: 'creative-decisions-filter-evidence-class',
  filterCampaignFamily: 'creative-decisions-filter-campaign-family',
  filterNetwork: 'creative-decisions-filter-network',
  filterFunnel: 'creative-decisions-filter-funnel',
  filterGeo: 'creative-decisions-filter-geo',
  filterProduct: 'creative-decisions-filter-product',
  filterPlan: 'creative-decisions-filter-plan',
  filterPrice: 'creative-decisions-filter-price',
  filterOriginalCurrency: 'creative-decisions-filter-original-currency',
  filterReportingCurrency: 'creative-decisions-filter-reporting-currency',
  filterMaturity: 'creative-decisions-filter-maturity',
  filterAvailability: (testId: string) => `${testId}-availability`,
  filterOrigin: 'creative-decisions-filter-origin',
  filterPurchaseMode: 'creative-decisions-filter-purchase-mode',
  filterSubscriptionEntry: 'creative-decisions-filter-subscription-entry',
  /** @deprecated Alias retained for older E2E consumers. */
  filterCurrency: 'creative-decisions-filter-original-currency',
  filterApply: 'creative-decisions-filter-apply',
  filterClear: 'creative-decisions-filter-clear',
  table: 'creative-decisions-table',
  loadedCount: 'creative-decisions-loaded-count',
  loadMore: 'creative-decisions-load-more',
  loadMoreError: 'creative-decisions-load-more-error',
  loadMoreRetry: 'creative-decisions-load-more-retry',
  row: (deploymentKey: string) => `creative-decisions-row-${encodeURIComponent(deploymentKey)}`,
  openDecision: (deploymentKey: string) => `creative-decisions-open-${encodeURIComponent(deploymentKey)}`,
  empty: 'creative-decisions-empty',
  loading: 'creative-decisions-loading',
  error: 'creative-decisions-error',
  drawer: 'creative-decision-drawer',
  detailLoading: 'creative-decision-detail-loading',
  detailError: 'creative-decision-detail-error',
  detailRetry: 'creative-decision-detail-retry',
  drawerClose: 'creative-decision-drawer-close',
  drawerDataAge: 'creative-decision-drawer-data-age',
  enrichmentThumbnail: (deploymentKey: string) => `creative-decision-enrichment-thumbnail-${encodeURIComponent(deploymentKey)}`,
  drawerEnrichment: 'creative-decision-drawer-enrichment',
  drawerEnrichmentMedia: 'creative-decision-drawer-enrichment-media',
  drawerEnrichmentMediaAt: (index: number) => `creative-decision-drawer-enrichment-media-${index}`,
  drawerEnrichmentLoading: 'creative-decision-drawer-enrichment-loading',
  drawerEnrichmentUnavailable: 'creative-decision-drawer-enrichment-unavailable',
  providerSourceThumbnail: (deploymentKey: string) => `creative-decision-provider-source-thumbnail-${encodeURIComponent(deploymentKey)}`,
  drawerProviderSource: 'creative-decision-drawer-provider-source',
  drawerProviderSourceMedia: (mediaId: string) => `creative-decision-drawer-provider-source-media-${encodeURIComponent(mediaId)}`,
  drawerProviderSourceMetadataOnly: 'creative-decision-drawer-provider-source-metadata-only',
  drawerProviderSourcePartial: 'creative-decision-drawer-provider-source-partial',
  drawerProviderSourceUnavailable: 'creative-decision-drawer-provider-source-unavailable',
  drawerProviderSourceSync: 'creative-decision-drawer-provider-source-sync',
  drawerProviderSourceSyncStatus: 'creative-decision-drawer-provider-source-sync-status',
  drawerProviderSourceSyncError: 'creative-decision-drawer-provider-source-sync-error',
  drawerIdentity: 'creative-decision-drawer-identity',
  drawerTaxonomy: 'creative-decision-drawer-taxonomy',
  drawerPromiseLineage: 'creative-decision-drawer-promise-lineage',
  drawerMoney: 'creative-decision-drawer-money',
  drawerWaterfall: 'creative-decision-drawer-waterfall',
  drawerWaterfallState: 'creative-decision-drawer-waterfall-state',
  drawerWaterfallStep: (component: string) => `creative-decision-drawer-waterfall-${component}`,
  drawerPredictionCurve: 'creative-decision-drawer-prediction-curve',
  drawerPredictionCurveState: 'creative-decision-drawer-prediction-curve-state',
  drawerPredictionCurvePoint: (day: number) => `creative-decision-drawer-prediction-curve-day-${day}`,
  drawerWatchOnlyPltv: 'creative-decision-drawer-watch-only-pltv',
  drawerWatchOnlyPltvState: 'creative-decision-drawer-watch-only-pltv-state',
  drawerWatchOnlyPltvDay: (date: string) => `creative-decision-drawer-watch-only-pltv-day-${date}`,
  drawerWatchOnlyPltvCalibration: 'creative-decision-drawer-watch-only-pltv-calibration',
  // C2-I5 (D2 split): two INDEPENDENT state chips — never one derived string.
  drawerSignalState: 'creative-decision-drawer-signal-state',
  drawerTargetMaturityState: 'creative-decision-drawer-target-maturity-state',
  drawerCalendarDynamics: 'creative-decision-drawer-calendar-dynamics',
  drawerCalendarDynamicsState: 'creative-decision-drawer-calendar-dynamics-state',
  drawerCalendarDynamicsDay: (date: string) => `creative-decision-drawer-calendar-dynamics-day-${date}`,
  drawerCalendarDynamicsProductFilter: 'creative-decision-drawer-calendar-dynamics-product-filter',
  drawerCalendarDynamicsProduct: (key: string) => `creative-decision-drawer-calendar-dynamics-product-${encodeURIComponent(key)}`,
  drawerProductEconomics: 'creative-decision-drawer-product-economics',
  drawerProductEconomicsState: 'creative-decision-drawer-product-economics-state',
  drawerProductEconomicsCurrency: (code: string) => `creative-decision-drawer-product-economics-currency-${encodeURIComponent(code)}`,
  drawerProductEconomicsProduct: (key: string) => `creative-decision-drawer-product-economics-product-${encodeURIComponent(key)}`,
  drawerProductEconomicsPayback: 'creative-decision-drawer-product-economics-payback',
  drawerProductEconomicsPaybackCoverage: 'creative-decision-drawer-product-economics-payback-coverage',
  drawerProductEconomicsSignals: 'creative-decision-drawer-product-economics-signals',
  drawerProductEconomicsPlanMix: 'creative-decision-drawer-product-economics-plan-mix',
  drawerProductEconomicsCancelIntent: (key: string) => `creative-decision-drawer-product-economics-cancel-intent-${encodeURIComponent(key)}`,
  /** W-A.6 (G5) — per-product `dataThrough` freshness caption (reconciledThrough + pending count). */
  drawerProductEconomicsDataThrough: 'creative-decision-drawer-product-economics-data-through',
  drawerFatigueCurve: 'creative-decision-drawer-fatigue-curve',
  drawerFatigueCurveState: 'creative-decision-drawer-fatigue-curve-state',
  drawerFatigueCurveDay: (date: string) => `creative-decision-drawer-fatigue-curve-day-${date}`,
  drawerFatigueCurveEarlyWatch: 'creative-decision-drawer-fatigue-curve-early-watch',
  drawerFatigueCurveSeasonality: 'creative-decision-drawer-fatigue-curve-seasonality',
  portfolioFatigueChip: (state: string) => `creative-decision-fatigue-chip-${state}`,
  drawerContextStatistics: (deploymentKey: string) => `creative-decision-context-statistics-${encodeURIComponent(deploymentKey)}`,
  drawerRecommendation: 'creative-decision-drawer-recommendation',
  drawerLifecycle: 'creative-decision-drawer-lifecycle',
  drawerTrust: 'creative-decision-drawer-trust',
  drawerMonetization: 'creative-decision-drawer-monetization',
  drawerSignals: 'creative-decision-drawer-signals',
  drawerEvidence: 'creative-decision-drawer-evidence',
  drawerCopilot: 'creative-decision-drawer-copilot',
  copilotQuestion: 'creative-decision-copilot-question',
  copilotAsk: 'creative-decision-copilot-ask',
  copilotAnswer: 'creative-decision-copilot-answer',
  drawerPrimaryAction: 'creative-decision-drawer-primary-action',
  stopEvidenceReview: 'creative-decision-stop-evidence-review',
  stopEvidenceReviewClose: 'creative-decision-stop-evidence-review-close',
  sourceLink: (kind: string) => `creative-decision-source-${kind}`,
} as const;

export const FUNNEL_INSIGHTS_FILTER_TEST_IDS = {
  strip: 'funnel-insights-filters',
  country: 'funnel-insights-filter-country',
  device: 'funnel-insights-filter-device',
  variant: 'funnel-insights-filter-variant',
  traitAdd: 'funnel-insights-trait-add',
  traitRow: (index: number) => `funnel-insights-trait-row-${index}`,
  traitKey: (index: number) => `funnel-insights-trait-key-${index}`,
  traitValues: (index: number) => `funnel-insights-trait-values-${index}`,
  traitRemove: (index: number) => `funnel-insights-trait-remove-${index}`,
  cohortsButton: 'funnel-insights-cohorts-button',
} as const;

/** Lives here (not in the component) so Playwright specs can import without pulling firebase deps. */
export const BREAKDOWN_SECTION_TEST_IDS = {
  section: 'funnel-reports-breakdown-section',
  traitSelect: 'funnel-reports-breakdown-trait-select',
  table: 'funnel-reports-breakdown-table',
  row: (segment: string) => `funnel-reports-breakdown-row-${segment}`,
  suppressedCell: (segment: string) => `funnel-reports-breakdown-suppressed-${segment}`,
} as const;

/** Spec D D1 — statistical-honesty surfaces (chips render on many report tables). */
export const STAT_TIER_TEST_IDS = {
  chip: 'stat-tier-chip',
  popover: 'stat-tier-popover',
  exploratoryLabel: 'stat-tier-exploratory',
  srmBanner: 'srm-stop-valve-banner',
} as const;

/** Spec D D1b — read-only analytics canvas (mode swap on the onboarding editor). */
export const ANALYTICS_CANVAS_TEST_IDS = {
  /** Editor-toolbar entry points (rendered by OnboardingCanvasEditorV2). */
  toggle: 'funnel-insights-toggle',
  refresh: 'funnel-insights-refresh',
  container: 'analytics-canvas-container',
  canvas: 'analytics-canvas',
  honestyBanner: 'analytics-honesty-banner',
  /** Report-period chip on the honesty banner («Jul 1 – Jul 8, 2026 (UTC)» / «All time»). */
  honestyBannerWindow: 'analytics-honesty-banner-window',
  /** Dashboard-parity Starts line («N starts · M people · this version»). */
  honestyBannerStarts: 'analytics-honesty-banner-starts',
  /** I4 — version chip + trafficked-versions dropdown on the honesty banner. */
  honestyBannerVersionChip: 'analytics-honesty-banner-version-chip',
  honestyBannerVersionItem: (versionId: string) => `analytics-honesty-banner-version-item-${versionId}`,
  /** I4 — zero-traffic landing warning (deep link without version / traffic-less head). */
  noTrafficWarning: 'analytics-canvas-no-traffic-warning',
  noTrafficSwitchTop: 'analytics-canvas-no-traffic-switch-top',
  /** Report-mode node filter: zero-traffic screens hidden by default. */
  showAllScreensToggle: 'analytics-canvas-show-all-screens',
  nodeCard: (screenId: string) => `analytics-node-card-${screenId}`,
  nodeCardHero: 'analytics-node-card-hero',
  nodeCardReach: 'analytics-node-card-reach',
  nodeCardMoney: 'analytics-node-card-money',
  nodeDrawer: 'analytics-node-drawer',
  nodeDrawerClose: 'analytics-node-drawer-close',
  /** FU part F (D-F3) — batch screen answers rendered in the node drawer. */
  nodeDrawerAnswers: 'analytics-node-drawer-answers',
  nodeDrawerVariable: 'analytics-node-drawer-variable',
  /** I6 — journeys↔people honesty bridge above the answers list. */
  nodeDrawerAnswersBridge: 'analytics-node-drawer-answers-bridge',
  nodeDrawerAnswersNoAnswer: 'analytics-node-drawer-answers-no-answer',
  nodeDrawerAnswersBridgeTooltip: 'analytics-node-drawer-answers-bridge-tooltip',
  /** Screen Audience Profile — who reached this screen (D-1…D-7). */
  nodeDrawerAudience: 'analytics-node-drawer-audience',
  nodeDrawerAudienceTooltip: 'analytics-node-drawer-audience-tooltip',
  nodeDrawerAudienceVariable: 'analytics-node-drawer-audience-variable',
  nodeDrawerAudienceCombos: 'analytics-node-drawer-audience-combos',
  nodeDrawerAudienceCombo: (index: number) => `analytics-node-drawer-audience-combo-${index}`,
  /** FU part F — honest «cached» marker next to the overlay refresh button. */
  overlayCachedMarker: 'funnel-insights-cached-marker',
  /** Must match FunnelEdgeMetricLabel's testid derivation. */
  edgeLabel: (canvasTransitionId: string) => `funnel-insights-edge-${canvasTransitionId}`,
  /** Canvas rework T4 — the red flow-loss down-stub under a leaking node. */
  flowLossStub: (screenId: string) => `analytics-flow-loss-stub-${screenId}`,
  /** Canvas rework T5 — bound-variable chip on the metric banner. */
  nodeVariableChip: (variableId: string) => `analytics-node-variable-chip-${variableId}`,
  /** Canvas rework T7 — encoding legend on the read-only canvas. */
  canvasLegend: 'analytics-canvas-legend',
  /** Report-mode header (P-6): edit actions hidden, report bar in the customActions slot. */
  reportModeBar: 'report-mode-bar',
  reportModeExit: 'report-mode-exit',
  reportModeFilters: 'report-mode-filters',
  /** F2 (FT-AC-083): page-level counting-unit toggle «People | Visits» on the report bar. */
  unitToggle: 'report-unit-toggle',
  unitToggleOption: (unit: 'people' | 'visits') => `report-unit-toggle-${unit}`,
  /** Read-only version display mirror (P-8) — the SWITCHER stays on the honesty banner. */
  reportModeVersionChip: 'report-mode-version-chip',
  reportModeWindowChip: 'report-mode-window-chip',
  /** I-B2 (P-9) — additive applied-filter chips row on the honesty banner. */
  honestyBannerFilterChips: 'analytics-honesty-banner-filter-chips',
  honestyBannerFilterChip: (index: number) => `analytics-honesty-banner-filter-chip-${index}`,
  /** Pre-answer zone (trait filters): where the filtered numbers start. */
  honestyBannerFilterZoneNote: 'analytics-honesty-banner-filter-zone-note',
  nodeCardObservability: 'analytics-node-card-observability',
  nodeDrawerObservability: 'analytics-node-drawer-observability',
  /** I-A — drop-off audience drawer (stub click → «Left after {screen}»). */
  dropoffDrawer: 'dropoff-audience-drawer',
  dropoffDrawerClose: 'dropoff-audience-drawer-close',
  dropoffDrawerTooltip: 'dropoff-audience-drawer-tooltip',
  dropoffDrawerVariable: 'dropoff-audience-variable',
  dropoffDrawerCombos: 'dropoff-audience-combos',
  dropoffDrawerCombo: (index: number) => `dropoff-audience-combo-${index}`,
  dropoffDrawerDegraded: 'dropoff-audience-degraded',
  dropoffDrawerEmpty: 'dropoff-audience-empty',
  /**
   * Provenance buckets (brief 2026-07-22) — SHARED by the node drawer and the
   * drop-off drawer: only one of them is ever open, so one id set suffices.
   */
  audienceBucketAfter: 'audience-bucket-after',
  audienceBucketOther: 'audience-bucket-other',
  audienceBucketDisclosureAfter: 'audience-bucket-disclosure-after',
  audienceBucketDisclosureOther: 'audience-bucket-disclosure-other',
  audienceReturnees: 'audience-returnees',
  audienceProvenanceSettings: 'audience-provenance-settings',
  audienceProvenanceSettingsTrigger: 'audience-provenance-settings-trigger',
  audienceProvenanceSwitch: (bucket: 'after' | 'other') => `audience-provenance-switch-${bucket}`,
  /** Part B — paywall outcome breakdown in the node drawer (below Money). */
  nodeDrawerPaywallOutcomes: 'analytics-node-drawer-paywall-outcomes',
  nodeDrawerPaywallOutcomesTooltip: 'analytics-node-drawer-paywall-outcomes-tooltip',
  paywallOutcomeRow: (key: string) => `paywall-outcome-row-${key}`,
  paywallOutcomesPlanMix: 'paywall-outcomes-plan-mix',
  paywallOutcomesExtras: 'paywall-outcomes-extras',
} as const;

/** I-B2 — Amplitude-style clause builder replacing the strip in report mode (P-7). */
export const REPORT_FILTER_PANEL_TEST_IDS = {
  panel: 'report-filter-panel',
  addClause: 'report-filter-add-clause',
  clauseRow: (index: number) => `report-filter-clause-${index}`,
  clauseProperty: (index: number) => `report-filter-clause-property-${index}`,
  clauseOperator: (index: number) => `report-filter-clause-operator-${index}`,
  clauseValues: (index: number) => `report-filter-clause-values-${index}`,
  clauseRemove: (index: number) => `report-filter-clause-remove-${index}`,
  apply: 'report-filter-apply',
  clearAll: 'report-filter-clear-all',
} as const;

export const DECISION_SCORECARD_TEST_IDS = {
  card: (testId: string, iterationId: string) => `decision-scorecard-${testId}-${iterationId}`,
  title: 'decision-scorecard-title',
  verdict: 'decision-scorecard-verdict',
  probability: 'decision-scorecard-probability',
  expectedLoss: 'decision-scorecard-expected-loss',
  reason: 'decision-scorecard-reason',
  detailsToggle: 'decision-scorecard-details-toggle',
  details: 'decision-scorecard-details',
  srm: 'decision-scorecard-srm',
  guardrails: 'decision-scorecard-guardrails',
  variantRow: (variantId: string) => `decision-scorecard-variant-${variantId}`,
  // R3-3 — decision actions (registry transition; records a decision, never moves traffic)
  declareWinnerButton: 'decision-scorecard-declare-winner',
  stopTestButton: 'decision-scorecard-stop-test',
  keepCollectingButton: 'decision-scorecard-keep-collecting',
  decisionDialog: 'decision-scorecard-decision-dialog',
  decisionRationale: 'decision-scorecard-decision-rationale',
  decisionWinnerSelect: 'decision-scorecard-decision-winner',
  decisionConfirm: 'decision-scorecard-decision-confirm',
  decisionError: 'decision-scorecard-decision-error',
  decisionRecorded: 'decision-scorecard-decision-recorded',
  // R3-1 — Δ vs control cell with the 95%-CI bar
  ciCell: (variantId: string) => `decision-scorecard-ci-${variantId}`,
} as const;

export const COHORT_BUILDER_TEST_IDS = {
  dialog: 'cohort-builder-dialog',
  list: 'cohort-builder-list',
  listItem: (id: string) => `cohort-builder-item-${id}`,
  applyButton: (id: string) => `cohort-builder-apply-${id}`,
  editButton: (id: string) => `cohort-builder-edit-${id}`,
  deleteButton: (id: string) => `cohort-builder-delete-${id}`,
  nameInput: 'cohort-builder-name-input',
  conditionRow: (index: number) => `cohort-builder-condition-row-${index}`,
  conditionKey: (index: number) => `cohort-builder-condition-key-${index}`,
  conditionValues: (index: number) => `cohort-builder-condition-values-${index}`,
  conditionRemove: (index: number) => `cohort-builder-condition-remove-${index}`,
  conditionAdd: 'cohort-builder-condition-add',
  estimate: 'cohort-builder-estimate',
  saveButton: 'cohort-builder-save-button',
  saveError: 'cohort-builder-save-error',
  cancelEdit: 'cohort-builder-cancel-edit',
} as const;
